import parse from 'html-react-parser';
import React, { useState, useEffect } from 'react';
import {
  forwardEmail,
  actionEvent,
  getDashboard,
  getVacancyById,
} from './../API';
import {
  message,
  Divider,
  Input,
  Modal,
  Form,
  Button,
  Switch,
  Popover,
  Spin,
  Empty,
  Icon,
  Tag,
  Statistic,
  Tabs,
  Badge,
  List,
  Card,
  Row,
  Col,
  Skeleton,
} from 'antd';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useMappedState, useDispatch } from 'redux-react-hook';
import { flexCenterRight, flexCenter } from './../theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronCircleRight,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';
import { faListUl } from '@fortawesome/free-solid-svg-icons';
import { faFileAlt } from '@fortawesome/free-solid-svg-icons';
import { faChartBar } from '@fortawesome/free-solid-svg-icons';
import { faFax } from '@fortawesome/free-solid-svg-icons';
import { faFileWord } from '@fortawesome/free-solid-svg-icons';
import { faUserCheck } from '@fortawesome/free-solid-svg-icons';
import { faCalendar } from '@fortawesome/free-solid-svg-icons';
// import { faPaperPlane } from '@fortawesome/free-solid-svg-icons'
// import { faInbox } from '@fortawesome/free-solid-svg-icons'
import { navigate } from '@reach/router';
import {
  s3,
  editorConfig,
  COLORS,
  EVENT_TYPE_COLOR,
  EVENT_TYPE,
} from './../utils';
import ReadEventPopConfirm from './../components/readEventPopConfirm';
import CustomAvatar from './../components/customAvatar';
import MyCalendar from './../components/myCalendar';
import EventsList from './../components/eventsList';
import moment from 'moment';
import {
  PieChart,
  Pie,
  Sector,
  Cell,
  ComposedChart,
  Area,
  Bar,
  Line,
  ResponsiveContainer,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from 'recharts';
import { format } from 'timeago.js';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from 'ckeditor5-custom-build/build/ckeditor';

const { TabPane } = Tabs;
const { TextArea } = Input;

const style = {
  dragableContent: {
    width: '100%',
    minHeight: '15vh',
  },
  dragableItemContent: {
    padding: '10px 10px 10px 10px',
    minHeight: '50px',
    backgroundColor: '#eeeeee',
    marginBottom: '5px',
  },
};

const preDefinedText = (name, body, sender) => {
  return `Dear ${name},\n\n${body}\n\nThanks,\n${sender}\n\n`;
};

function Dashboard() {
  const dispatch = useDispatch();
  const session = useMappedState((state) => state.session);
  const dashboard = useMappedState((state) => state.dashboard);

  const [loading, setLoading] = useState(true);
  const [activeIndex, setActiveIndex] = useState(0);

  const [vacancies, setVacancies] = useState([]);
  const [updating, setUpdating] = useState(false);

  const [vacancyLoading, setVacancyLoading] = useState(false);

  const [showEditVacancyModal, setShowEditVacancyModal] = useState(false);
  const [vacancyEventEntry, setVacancyEventEntry] = useState(null);

  const [showVacancyDetailModal, setShowVacancyDetailModal] = useState(false);
  const [vacancyDetailLoading, setVacancyDetailLoading] = useState(false);
  const [vacancyDetailData, setVacancyDetailData] = useState([]);

  const [eventEntry, setEventEntry] = useState(null);

  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [emailBody, setEmailBody] = useState('');
  const [emailSending, setEmailSending] = useState(false);

  useEffect(() => {
    async function fetchData() {
      const response = await getDashboard(session.authToken);
      let dataVacancy;
      if (response.data.data.listOfVacancy) {
        dataVacancy = response.data.data.listOfVacancy.map((i) => {
          return {
            ...i,
            ...{
              contactAvatarUrl: i.contact_doc
                ? `${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/contact/${i.contact_doc.id}.jpeg`
                : '',
            },
          };
        });
      }
      setVacancies(dataVacancy);

      dispatch({ type: 'INIT_DASHBOARD', payload: response.data.data });
      setLoading(false);
    }
    dispatch({ type: 'SET_INDEX', payload: '1' });
    fetchData();

    // eslint-disable-next-line
  }, []);

  const renderEmailButton = (i) => {
    if (data6Sub.map((each) => each.parent).includes(i.id)) {
      const data = data6Sub.find((item) => item.parent === i.id);
      return (
        <Popover
          overlayStyle={{
            width: '60vw',
            maxHeight: '350px',
            overflowY: 'auto',
            border: `1px solid #408EBA`,
            borderRadius: '4px',
          }}
          placement="bottomLeft"
          content={
            <div>{data && data.body ? parse(data.body) : 'Not/Available'}</div>
          }
        >
          <Icon
            type="mail"
            theme="twoTone"
            twoToneColor="#52c41a"
            style={{ fontSize: '24px' }}
          />
        </Popover>
      );
    } else {
      return (
        <div>
          <Button
            disabled={i.user_doc.id !== session.id || i.isRead}
            size="small"
            onClick={() => {
              setOpenEmailModal(true);
              setEventEntry(i);
              setEmailBody(
                preDefinedText(
                  i.contact_doc.firstname,
                  'Just to quickly follow up the below attached candidate, do you have any interests or needs in team please? Please feel free to let me know when is a good time to call you for a further discussion.',
                  session.firstname,
                ),
              );
            }}
          >
            <Icon type="mail" />
          </Button>
        </div>
      );
    }
  };

  const readEventButton = (i) => {
    if (i.user_doc.id === session.id) {
      if (i.isRead) {
        return (
          <div style={{ marginRight: '3px' }}>
            <Icon
              type="check-circle"
              theme="twoTone"
              twoToneColor="#52c41a"
              style={{ fontSize: '24px' }}
            />
          </div>
        );
      }
      return <ReadEventPopConfirm event={i} />;
    }
    return (
      <CustomAvatar
        showTooltip={true}
        tooltipTitle={`${i.user_doc.firstname} ${i.user_doc.lastname}`}
        colourCode={i.user_doc.firstname.charAt(0).toLowerCase()}
        char={`${i.user_doc.firstname.charAt(0).toUpperCase()}${i.user_doc.lastname.charAt(0).toUpperCase()}`}
        charSize={12}
        size={30}
        src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/user/${i.user_doc.id}.jpeg`}
      />
    );
  };

  const NewVacancy = ({ form }) => {
    const { getFieldDecorator } = form;

    const [editVacancyLoading, setEditVacancyLoading] = useState(false);
    const [vacancyBody, setVacancyBody] = useState(null);

    useEffect(() => {
      setVacancyBody(vacancyEventEntry.body);
    }, []);

    return (
      <Modal
        zIndex={100}
        centered={true}
        title="Edit Vacancy"
        closable={false}
        visible={showEditVacancyModal}
        width="90%"
        footer={[
          <Button
            disabled={editVacancyLoading}
            key="cancel"
            onClick={() => {
              setShowEditVacancyModal(false);
              setVacancyEventEntry(null);
              setVacancyBody('');
            }}
          >
            <Icon type="close" />
            Cancel
          </Button>,
          <Button
            key="create"
            type="primary"
            onClick={async () => {
              const formResult = await form.validateFields();

              setEditVacancyLoading(true);
              const result = await actionEvent(session.authToken, {
                type: 'edit',
                id: vacancyEventEntry.id,
                title: formResult.title,
                body: vacancyBody,
              });

              if (result.data.responseCode === 0) {
                const response = await getDashboard(session.authToken);

                let dataVacancy;
                if (response.data.data.listOfVacancy) {
                  dataVacancy = response.data.data.listOfVacancy.map((i) => {
                    return {
                      ...i,
                      ...{
                        contactAvatarUrl: i.contact_doc
                          ? `${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/contact/${i.contact_doc.id}.jpeg`
                          : '',
                      },
                    };
                  });
                }
                setVacancies(dataVacancy);

                setEditVacancyLoading(false);
                setShowEditVacancyModal(false);
                message.success(result.data.message);
              } else {
                setEditVacancyLoading(false);
                message.error(result.data.message.toString());
              }
            }}
          >
            {editVacancyLoading ? (
              <Icon type="loading" />
            ) : (
              <Icon type="check" />
            )}
            Submit
          </Button>,
        ]}
      >
        <div>
          <Row>
            <Col span={24}>
              <Form.Item>
                {getFieldDecorator('title', {
                  initialValue: vacancyEventEntry.title,
                  rules: [
                    { required: true, message: 'Please input vacancy title!' },
                  ],
                })(
                  <Input
                    autoComplete="off"
                    placeholder="Vacancy title"
                    disabled={editVacancyLoading}
                  />,
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <CKEditor
                disabled={editVacancyLoading}
                value={vacancyBody}
                data={vacancyBody}
                editor={Editor}
                config={editorConfig}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  setVacancyBody(data);
                }}
              />
            </Col>
          </Row>
        </div>
      </Modal>
    );
  };

  const NewVacancyForm = Form.create({ name: 'new-vacancy' })(NewVacancy);

  const renderVacancyButton = (i) => {
    if (i.user_doc.id === session.id) {
      return (
        <>
          <div style={{ marginTop: '3px' }}>
            <Switch
              size="small"
              defaultChecked={i.enable}
              onChange={async () => {
                setVacancyLoading(true);
                const res = await actionEvent(session.authToken, {
                  type: 'enable/disable',
                  id: i.id,
                  value: !i.enable,
                });
                if (res.data.responseCode === 0) {
                  const response = await getDashboard(session.authToken);

                  let dataVacancy;
                  if (response.data.data.listOfVacancy) {
                    dataVacancy = response.data.data.listOfVacancy.map((i) => {
                      return {
                        ...i,
                        ...{
                          contactAvatarUrl: i.contact_doc
                            ? `${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/contact/${i.contact_doc.id}.jpeg`
                            : '',
                        },
                      };
                    });
                  }
                  setVacancies(dataVacancy);

                  message.success(res.data.message);
                  setVacancyLoading(false);
                } else {
                  message.error(res.data.message);
                  setVacancyLoading(false);
                }
              }}
            />
          </div>
          &nbsp;&nbsp;&nbsp;
          <div style={{ marginTop: '6px' }}>
            <Button
              size="small"
              onClick={() => {
                setShowEditVacancyModal(true);
                setVacancyEventEntry(i);
              }}
            >
              <Icon type="form" />
            </Button>
            &nbsp;
            <Button
              size="small"
              onClick={async () => {
                setShowVacancyDetailModal(true);
                setVacancyDetailLoading(true);
                const data = await getVacancyById(session.authToken, i.id);
                setVacancyDetailData(data.data.interviews);
                setVacancyDetailLoading(false);
              }}
            >
              <Icon type="plus" />
            </Button>
          </div>
        </>
      );
    }
    return (
      <>
        <Button
          size="small"
          onClick={async () => {
            setShowVacancyDetailModal(true);
            setVacancyDetailLoading(true);
            const data = await getVacancyById(session.authToken, i.id);
            setVacancyDetailData(data.data.interviews);
            setVacancyDetailLoading(false);
          }}
        >
          <Icon type="plus" />
        </Button>
        &nbsp;
        <CustomAvatar
          showTooltip={true}
          tooltipTitle={`${i.user_doc.firstname} ${i.user_doc.lastname}`}
          colourCode={i.user_doc.firstname.charAt(0).toLowerCase()}
          char={`${i.user_doc.firstname.charAt(0).toUpperCase()}${i.user_doc.lastname.charAt(0).toUpperCase()}`}
          charSize={12}
          size={30}
          src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/user/${i.user_doc.id}.jpeg`}
        />
      </>
    );
  };

  const renderFollowUpEvent = (i, show, forCandidate, showEvent, showEmail) => {
    const arrContact = [];
    const arrCandidate = [];

    if (i.contact_doc && i.contact_doc.tel && i.contact_doc.tel !== '') {
      arrContact.push(i.contact_doc.tel);
    }
    if (i.contact_doc && i.contact_doc.mobile && i.contact_doc.mobile !== '') {
      arrContact.push(i.contact_doc.mobile);
    }

    if (
      i.candidate_doc &&
      i.candidate_doc.email &&
      i.candidate_doc.email !== ''
    ) {
      arrCandidate.push(i.candidate_doc.email);
    }
    if (
      i.candidate_doc &&
      i.candidate_doc.mobile &&
      i.candidate_doc.mobile !== ''
    ) {
      arrCandidate.push(i.candidate_doc.mobile);
    }
    if (
      i.candidate_doc &&
      i.candidate_doc.linkedin &&
      i.candidate_doc.linkedin !== ''
    ) {
      arrCandidate.push(i.candidate_doc.linkedin);
    }

    return (
      <Row>
        {show ? (
          <Col span={3}>
            <div style={{ marginTop: '5px' }}>
              <Tag color={EVENT_TYPE_COLOR[i.type]}>
                {EVENT_TYPE[i.type].text}
              </Tag>
            </div>
          </Col>
        ) : null}
        <Col span={show ? 12 : forCandidate ? 10 : showEvent ? 14 : 15}>
          {i.contact_doc ? (
            <React.Fragment>
              <CustomAvatar
                colourCode={i.contact_doc.firstname.charAt(0).toLowerCase()}
                char={`${i.contact_doc.firstname.charAt(0).toUpperCase()}${i.contact_doc.lastname.charAt(0).toUpperCase()}`}
                src={i.contactAvatarUrl}
              />
              <b
                onClick={() => {
                  navigate(`/contacts/${i.contact_doc.id}`);
                }}
                style={{
                  marginLeft: '5px',
                  cursor: 'pointer',
                  marginTop: '5px',
                }}
              >
                {`${i.contact_doc.firstname} ${i.contact_doc.lastname}`}
              </b>
              &nbsp;
              <Tag
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  navigate(`/clients/${i.client_doc.id}`);
                }}
              >
                {i.client_doc.name}
              </Tag>
            </React.Fragment>
          ) : null}
          {i.candidate_doc ? (
            <React.Fragment>
              <Row>
                <Col span={4}>
                  <CustomAvatar
                    colourCode={i.candidate_doc.firstname
                      .charAt(0)
                      .toLowerCase()}
                    char={`${i.candidate_doc.firstname.charAt(0).toUpperCase()}${i.candidate_doc.lastname.charAt(0).toUpperCase()}`}
                    src={i.candidateAvatarUrl}
                  />
                </Col>
                <Col span={20}>
                  <span
                    onClick={() => {
                      navigate(`/candidates/${i.candidate_doc.id}`);
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    <b>
                      {`${i.candidate_doc.firstname} ${i.candidate_doc.lastname}`}
                    </b>
                    <div>
                      Service:{' '}
                      {i.candidate_doc.service ? (
                        <i>{i.candidate_doc.service}</i>
                      ) : (
                        <i>N/A</i>
                      )}
                    </div>
                    <div>
                      Position:{' '}
                      {i.candidate_doc.position ? (
                        <i>{i.candidate_doc.position}</i>
                      ) : (
                        <i>N/A</i>
                      )}
                    </div>
                  </span>
                </Col>
              </Row>
            </React.Fragment>
          ) : null}
        </Col>

        <Col span={forCandidate ? 10 : 5}>
          {i.contact_doc ? (
            <div style={{ marginTop: '3px' }}>
              {arrContact.length > 0 ? (
                arrContact.join(', ')
              ) : (
                <div style={{ color: '#cccccc' }}>Not Available</div>
              )}
            </div>
          ) : i.candidate_doc ? (
            <div style={{ marginTop: '3px' }}>
              {arrCandidate.length > 0 ? (
                arrCandidate.join(', ')
              ) : (
                <div style={{ color: '#cccccc' }}>Not Available</div>
              )}
            </div>
          ) : null}
        </Col>
        <Col span={2}>
          <div style={flexCenterRight}>
            <span style={{ marginTop: '5px', color: '#aaa', fontSize: '12px' }}>
              <i>
                {format(
                  new Date(moment(i.createdAt).format('YYYY-MM-DD HH:mm:ss')),
                )}
              </i>
            </span>
          </div>
        </Col>
        <Col span={1} style={flexCenter}>
          {i.emailId.length > 0 && showEmail && renderEmailButton(i)}
        </Col>
        <Col span={1} style={flexCenterRight}>
          {readEventButton(i)}
        </Col>
      </Row>
    );
  };

  const renderReadEvent = (i, show, forCandidate, showEvent, showEmail) => {
    const arrContact = [];
    const arrCandidate = [];

    if (i.contact_doc && i.contact_doc.tel && i.contact_doc.tel !== '') {
      arrContact.push(i.contact_doc.tel);
    }
    if (i.contact_doc && i.contact_doc.mobile && i.contact_doc.mobile !== '') {
      arrContact.push(i.contact_doc.mobile);
    }

    if (
      i.candidate_doc &&
      i.candidate_doc.email &&
      i.candidate_doc.email !== ''
    ) {
      arrCandidate.push(i.candidate_doc.email);
    }
    if (
      i.candidate_doc &&
      i.candidate_doc.mobile &&
      i.candidate_doc.mobile !== ''
    ) {
      arrCandidate.push(i.candidate_doc.mobile);
    }
    if (
      i.candidate_doc &&
      i.candidate_doc.linkedin &&
      i.candidate_doc.linkedin !== ''
    ) {
      arrCandidate.push(i.candidate_doc.linkedin);
    }

    return (
      <Row>
        {show ? (
          <Col span={3}>
            <div style={{ marginTop: '5px' }}>
              <Tag color={EVENT_TYPE_COLOR[i.type]}>
                {EVENT_TYPE[i.type].text}
              </Tag>
            </div>
          </Col>
        ) : null}
        <Col span={show ? 12 : forCandidate ? 10 : showEvent ? 14 : 15}>
          <Row>
            <Col span={15}>
              {i.contact_doc ? (
                <React.Fragment>
                  <CustomAvatar
                    colourCode={i.contact_doc.firstname.charAt(0).toLowerCase()}
                    char={`${i.contact_doc.firstname.charAt(0).toUpperCase()}${i.contact_doc.lastname.charAt(0).toUpperCase()}`}
                    src={i.contactAvatarUrl}
                  />
                  <b
                    onClick={() => {
                      navigate(`/contacts/${i.contact_doc.id}`);
                    }}
                    style={{
                      marginLeft: '5px',
                      cursor: 'pointer',
                      marginTop: '5px',
                    }}
                  >
                    {`${i.contact_doc.firstname} ${i.contact_doc.lastname}`}
                  </b>
                  &nbsp;
                  <Tag
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      navigate(`/clients/${i.client_doc.id}`);
                    }}
                  >
                    {i.client_doc.name}
                  </Tag>
                </React.Fragment>
              ) : null}
            </Col>
            <Col span={9}>
              {i.candidate_doc ? (
                <React.Fragment>
                  <Row>
                    <Col span={4}>
                      <CustomAvatar
                        colourCode={i.candidate_doc.firstname
                          .charAt(0)
                          .toLowerCase()}
                        char={`${i.candidate_doc.firstname.charAt(0).toUpperCase()}${i.candidate_doc.lastname.charAt(0).toUpperCase()}`}
                        src={i.candidateAvatarUrl}
                      />
                    </Col>
                    <Col span={20}>
                      <span
                        onClick={() => {
                          navigate(`/candidates/${i.candidate_doc.id}`);
                        }}
                        style={{ cursor: 'pointer' }}
                      >
                        <b>
                          {`${i.candidate_doc.firstname} ${i.candidate_doc.lastname}`}
                        </b>
                        <div>
                          Service:{' '}
                          {i.candidate_doc.service ? (
                            <i>{i.candidate_doc.service}</i>
                          ) : (
                            <i>N/A</i>
                          )}
                        </div>
                        <div>
                          Position:{' '}
                          {i.candidate_doc.position ? (
                            <i>{i.candidate_doc.position}</i>
                          ) : (
                            <i>N/A</i>
                          )}
                        </div>
                      </span>
                    </Col>
                  </Row>
                </React.Fragment>
              ) : null}
            </Col>
          </Row>
        </Col>
        {showEvent ? (
          <Col span={1}>
            <Popover
              overlayStyle={{
                width: '50vw',
              }}
              placement="top"
              title="Details"
              content={
                <>
                  {i.body !== '' ? (
                    <div
                      style={{
                        maxHeight: '275px',
                        overflow: 'auto',
                      }}
                    >
                      {parse(i.body)}
                    </div>
                  ) : (
                    <span style={{ color: '#ddd' }}>Empty body</span>
                  )}
                </>
              }
            >
              <FontAwesomeIcon
                icon={faInfoCircle}
                style={{ fontSize: '18px', color: '#72A0C1' }}
              />
            </Popover>
          </Col>
        ) : null}
        <Col span={forCandidate ? 10 : 5}>
          {i.contact_doc ? (
            <div style={{ marginTop: '3px' }}>
              {arrContact.length > 0 ? (
                arrContact.join(', ')
              ) : (
                <div style={{ color: '#cccccc' }}>Not Available</div>
              )}
            </div>
          ) : i.candidate_doc ? (
            <div style={{ marginTop: '3px' }}>
              {arrCandidate.length > 0 ? (
                arrCandidate.join(', ')
              ) : (
                <div style={{ color: '#cccccc' }}>Not Available</div>
              )}
            </div>
          ) : null}
        </Col>
        <Col span={2}>
          <div style={flexCenterRight}>
            <span style={{ marginTop: '5px', color: '#aaa', fontSize: '12px' }}>
              <i>
                {format(
                  new Date(moment(i.createdAt).format('YYYY-MM-DD HH:mm:ss')),
                )}
              </i>
            </span>
          </div>
        </Col>
        <Col span={1} style={flexCenter}>
          {i.emailId.length > 0 && showEmail && renderEmailButton(i)}
        </Col>
        <Col span={1} style={flexCenterRight}>
          {readEventButton(i)}
        </Col>
      </Row>
    );
  };

  const renderVacancy = (i, order) => {
    const bgColor = i.enable ? '#CB4154' : '#ccc';
    return (
      <>
        <Row>
          <Col span={1}>
            <div style={{ marginTop: '3px' }}>
              <Badge count={order} style={{ backgroundColor: bgColor }} />
            </div>
          </Col>
          <Col span={10}>
            <div style={{ marginTop: '5px' }}>
              <span style={{ fontWeight: 500 }}>{i.title}</span>
            </div>
          </Col>
          <Col span={1}>
            <div style={{ marginTop: '6px' }}>
              <Popover
                overlayStyle={{
                  width: '50vw',
                }}
                placement="top"
                title="Vacancy Description"
                content={<>{parse(i.body)}</>}
              >
                <FontAwesomeIcon
                  icon={faInfoCircle}
                  style={{ fontSize: '18px', color: '#72A0C1' }}
                />
              </Popover>
            </div>
          </Col>
          <Col span={7}>
            {i.contact_doc ? (
              <React.Fragment>
                <Row>
                  <Col span={3}>
                    <CustomAvatar
                      colourCode={i.contact_doc.firstname
                        .charAt(0)
                        .toLowerCase()}
                      char={`${i.contact_doc.firstname.charAt(0).toUpperCase()}${i.contact_doc.lastname.charAt(0).toUpperCase()}`}
                      src={i.contactAvatarUrl}
                    />
                  </Col>
                  <Col span={21}>
                    <b
                      onClick={() => {
                        navigate(`/contacts/${i.contact_doc.id}`);
                      }}
                      style={{
                        marginLeft: '5px',
                        cursor: 'pointer',
                        marginTop: '5px',
                      }}
                    >
                      {`${i.contact_doc.firstname} ${i.contact_doc.lastname}`}
                    </b>
                    <div>
                      <Tag
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          navigate(`/clients/${i.client_doc.id}`);
                        }}
                      >
                        {i.client_doc.name}
                      </Tag>
                    </div>
                  </Col>
                </Row>
              </React.Fragment>
            ) : null}
          </Col>
          <Col span={2}>
            <div style={flexCenterRight}>
              <span
                style={{ marginTop: '5px', color: '#aaa', fontSize: '12px' }}
              >
                <i>
                  {format(
                    new Date(moment(i.createdAt).format('YYYY-MM-DD HH:mm:ss')),
                  )}
                </i>
              </span>
            </div>
          </Col>
          <Col span={3} style={flexCenterRight}>
            {renderVacancyButton(i)}
          </Col>
        </Row>
      </>
    );
  };

  const renderInterview = (i) => {
    return (
      <Row>
        {/* <Col span={1}>
          <div style={{marginTop: '5px'}}>
          {
            i.isEmail ?
            <span>
              <FontAwesomeIcon
                style={{color: '#B0BF1A'}}
                icon={i.emailType === 'sent' ? faPaperPlane : faInbox} />&nbsp;&nbsp;
            </span>
            :
            null
          }
          </div>
        </Col> */}
        <Col span={18}>
          {i.contact_doc ? (
            <React.Fragment>
              <Col span={3}>
                <CustomAvatar
                  colourCode={i.contact_doc.firstname.charAt(0).toLowerCase()}
                  char={`${i.contact_doc.firstname.charAt(0).toUpperCase()}${i.contact_doc.lastname.charAt(0).toUpperCase()}`}
                  src={i.contactAvatarUrl}
                />
              </Col>
              <Col span={21}>
                <span
                  onClick={() => {
                    navigate(`/contacts/${i.contact_doc.id}`);
                  }}
                  style={{
                    marginLeft: '5px',
                    cursor: 'pointer',
                    marginTop: '5px',
                  }}
                >
                  <b>{`${i.contact_doc.firstname} ${i.contact_doc.lastname}`}</b>
                </span>
                &nbsp;
                <Tag
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    navigate(`/clients/${i.client_doc.id}`);
                  }}
                >
                  {i.client_doc.name}
                </Tag>
              </Col>
            </React.Fragment>
          ) : null}
          {i.candidate_doc && i.contact_doc ? <span>&nbsp;&nbsp;</span> : null}
          {i.candidate_doc ? (
            <React.Fragment>
              <Row>
                <Col span={3}>
                  <CustomAvatar
                    colourCode={i.candidate_doc.firstname
                      .charAt(0)
                      .toLowerCase()}
                    char={`${i.candidate_doc.firstname.charAt(0).toUpperCase()}${i.candidate_doc.lastname.charAt(0).toUpperCase()}`}
                    src={i.candidateAvatarUrl}
                  />
                </Col>
                <Col span={21}>
                  <div
                    onClick={() => {
                      navigate(`/candidates/${i.candidate_doc.id}`);
                    }}
                    style={{ marginLeft: '5px', cursor: 'pointer' }}
                  >
                    <b>
                      {`${i.candidate_doc.firstname} ${i.candidate_doc.lastname}`}
                    </b>
                    <div>
                      Service:{' '}
                      {i.candidate_doc.service ? (
                        <i>{i.candidate_doc.service}</i>
                      ) : (
                        <i>N/A</i>
                      )}
                    </div>
                    <div>
                      Position:{' '}
                      {i.candidate_doc.position ? (
                        <i>{i.candidate_doc.position}</i>
                      ) : (
                        <i>N/A</i>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
            </React.Fragment>
          ) : null}
        </Col>
        <Col span={6}>
          <div style={flexCenterRight}>
            <span style={{ marginTop: '5px', color: '#aaa', fontSize: '12px' }}>
              <i>
                {format(
                  new Date(moment(i.createdAt).format('YYYY-MM-DD HH:mm:ss')),
                )}
              </i>
            </span>
          </div>
        </Col>
      </Row>
    );
  };

  const renderNewCandidate = (i) => {
    return (
      <Row>
        <Col span={3}>
          <CustomAvatar
            colourCode={i.firstname.charAt(0).toLowerCase()}
            char={`${i.firstname.charAt(0).toUpperCase()}${i.lastname.charAt(0).toUpperCase()}`}
            src={i.avatarUrl}
          />
        </Col>
        <Col span={15}>
          <div
            onClick={() => {
              navigate(`/candidates/${i.id}`);
            }}
            style={{ cursor: 'pointer', marginTop: '0px' }}
          >
            <div>
              <b>{`${i.firstname} ${i.lastname}`}</b>
            </div>
            <div>Service: {i.service ? <i>{i.service}</i> : <i>N/A</i>}</div>
            <div>Position: {i.position ? <i>{i.position}</i> : <i>N/A</i>}</div>
          </div>
        </Col>
        <Col span={6}>
          <div style={flexCenterRight}>
            <span style={{ marginTop: '5px', color: '#aaa', fontSize: '12px' }}>
              <i>
                {format(
                  new Date(moment(i.createdAt).format('YYYY-MM-DD HH:mm:ss')),
                )}
              </i>
            </span>
          </div>
        </Col>
      </Row>
    );
  };

  const renderCandidate = (i, k) => {
    return (
      <Row>
        <Col span={2}>
          <div style={{ marginTop: '5px' }}>{`${k + 1}.`}</div>
        </Col>
        <Col span={3}>
          <CustomAvatar
            colourCode={i.candidate.firstname.charAt(0).toLowerCase()}
            char={`${i.candidate.firstname.charAt(0).toUpperCase()}${i.candidate.lastname.charAt(0).toUpperCase()}`}
            src={i.candidate.avatarUrl}
          />
        </Col>
        <Col span={17}>
          <div
            onClick={() => {
              navigate(`/candidates/${i.candidate.id}`);
            }}
            style={{ cursor: 'pointer', marginTop: '0px' }}
          >
            <b>{`${i.candidate.firstname} ${i.candidate.lastname}`}</b>
            <div>
              Service:{' '}
              {i.candidate.service ? <i>{i.candidate.service}</i> : <i>N/A</i>}
            </div>
            <div>
              Position:{' '}
              {i.candidate.position ? (
                <i>{i.candidate.position}</i>
              ) : (
                <i>N/A</i>
              )}
            </div>
          </div>
        </Col>

        <Col span={2}>
          <div style={flexCenterRight}>
            <div style={{ marginTop: '5px' }}>
              <Badge count={i.count} />
            </div>
          </div>
        </Col>
      </Row>
    );
  };

  const renderCard = (color, number, text, url) => {
    return (
      <Card
        size="small"
        style={{
          marginLeft: '5px',
          marginRight: '5px',
          backgroundColor: color,
        }}
      >
        <Statistic
          title=""
          valueStyle={{ fontSize: '28px', color: '#fff' }}
          value={number}
        />
        <Row>
          <Col span={18}>
            <div style={{ color: 'white' }}>Total {text}</div>
          </Col>
          <Col span={6}>
            <div style={flexCenterRight}>
              <FontAwesomeIcon
                onClick={() => {
                  navigate(url);
                }}
                style={{
                  cursor: 'pointer',
                  marginTop: '5px',
                  fontSize: '14px',
                  color: 'white',
                }}
                icon={faChevronCircleRight}
              />
            </div>
          </Col>
        </Row>
      </Card>
    );
  };

  const CustomizedAxisTick = (props) => {
    const { x, y, payload } = props;
    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={0} dy={16} textAnchor="end" fill="#666">
          {payload.value}
        </text>
      </g>
    );
  };

  let data3 = [];

  if (dashboard.groupByCandidates && dashboard.groupByCVSent) {
    let temp = dashboard.groupByCandidates.reduce((acc, { week }) => {
      acc[week] = {};
      return acc;
    }, {});

    for (const each of dashboard.groupByCandidates) {
      temp[each.week] = { candidates: each.count };
    }

    for (const each of dashboard.groupByCVSent) {
      temp[each.week] = Object.assign({}, temp[each.week], {
        spec_and_cvsent: each.count,
      });
    }

    data3 = Object.keys(temp).map((e) => {
      return {
        week: `week ${e}`,
        candidates: temp[e].candidates,
        spec_and_cvsent: temp[e].spec_and_cvsent,
      };
    });
  }

  let data = [];

  if (dashboard.eventsGroupByDate) {
    data = dashboard.eventsGroupByDate.map((i) => {
      return {
        date: moment(i.date).format('ddd'),
        events: i.count,
      };
    });
  }

  let data1 = [];

  if (dashboard.groupByType) {
    data1 = dashboard.groupByType.map((i) => {
      return {
        name: EVENT_TYPE[i._id].text,
        value: i.count,
      };
    });
  }

  let data2 = [];
  if (dashboard.eventsGroupByCandidate) {
    data2 = dashboard.eventsGroupByCandidate.map((i) => {
      return {
        _id: i._id,
        count: i.count,
        candidate: {
          ...i.candidate,
          ...{
            avatarUrl: `${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/candidate/${i.candidate.id}.jpeg`,
          },
        },
      };
    });
  }

  let data4 = [];
  if (dashboard.listOfCandidates) {
    data4 = dashboard.listOfCandidates.map((i) => {
      return {
        ...i,
        ...{
          avatarUrl: `${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/candidate/${i.id}.jpeg`,
        },
      };
    });
  }

  let data5 = [];
  if (dashboard.listOfInterview) {
    data5 = dashboard.listOfInterview.map((i) => {
      return {
        ...i,
        ...{
          candidateAvatarUrl: i.candidate_doc
            ? `${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/candidate/${i.candidate_doc.id}.jpeg`
            : '',
        },
        ...{
          contactAvatarUrl: i.contact_doc
            ? `${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/contact/${i.contact_doc.id}.jpeg`
            : '',
        },
      };
    });
  }

  let data6 = [];
  let data6Sub = [];
  if (dashboard.listOfCVSent) {
    const allData = dashboard.listOfCVSent.map((i) => {
      return {
        ...i,
        ...{
          candidateAvatarUrl: i.candidate_doc
            ? `${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/candidate/${i.candidate_doc.id}.jpeg`
            : '',
        },
        ...{
          contactAvatarUrl: i.contact_doc
            ? `${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/contact/${i.contact_doc.id}.jpeg`
            : '',
        },
      };
    });
    data6 = allData.filter((i) => !i.parent);
    data6Sub = allData.filter((i) => i.parent);
  }

  let data7 = [];
  if (dashboard.listOfToBD) {
    data7 = dashboard.listOfToBD.map((i) => {
      return {
        ...i,
        ...{
          candidateAvatarUrl: i.candidate_doc
            ? `${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/candidate/${i.candidate_doc.id}.jpeg`
            : '',
        },
        ...{
          contactAvatarUrl: i.contact_doc
            ? `${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/contact/${i.contact_doc.id}.jpeg`
            : '',
        },
      };
    });
  }

  let data8 = [];
  if (dashboard.listOfToFU) {
    data8 = dashboard.listOfToFU.map((i) => {
      return {
        ...i,
        ...{
          candidateAvatarUrl: i.candidate_doc
            ? `${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/candidate/${i.candidate_doc.id}.jpeg`
            : '',
        },
        ...{
          contactAvatarUrl: i.contact_doc
            ? `${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/contact/${i.contact_doc.id}.jpeg`
            : '',
        },
      };
    });
  }

  const renderActiveShape = (props) => {
    const RADIAN = Math.PI / 180;
    const {
      cx,
      cy,
      midAngle,
      innerRadius,
      outerRadius,
      startAngle,
      endAngle,
      fill,
      payload,
      percent,
      value,
    } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const mx = cx + (outerRadius + 30) * cos;
    const my = cy + (outerRadius + 30) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    const ey = my;
    const textAnchor = cos >= 0 ? 'start' : 'end';

    return (
      <g>
        <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
          {payload.name}
        </text>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
        />
        <Sector
          cx={cx}
          cy={cy}
          startAngle={startAngle}
          endAngle={endAngle}
          innerRadius={outerRadius + 6}
          outerRadius={outerRadius + 10}
          fill={fill}
        />
        <path
          d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
          stroke={fill}
          fill="none"
        />
        <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
        <text
          x={ex + (cos >= 0 ? 1 : -1) * 12}
          y={ey}
          textAnchor={textAnchor}
          fill="#333"
        >{`${value}`}</text>
        <text
          x={ex + (cos >= 0 ? 1 : -1) * 12}
          y={ey}
          dy={18}
          textAnchor={textAnchor}
          fill="#999"
        >
          {`${(percent * 100).toFixed(2)}%`}
        </text>
      </g>
    );
  };

  const onPieEnter = (_, index) => {
    setActiveIndex(index);
  };

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  async function onDragEnd(result) {
    if (!result.destination) {
      return;
    }

    const $ = reorder(vacancies, result.source.index, result.destination.index);

    setVacancies($);

    setUpdating(true);
    const res = await actionEvent(session.authToken, {
      type: 'orders',
      eventIds: $.map((i) => i.id),
    });
    if (res.data.responseCode === 0) {
      message.success(res.data.message);
    } else {
      message.error(res.data.message);
    }
    setUpdating(false);
  }

  return loading ? (
    <div>
      <p>Loading...</p>
      <Skeleton active />
    </div>
  ) : (
    <React.Fragment>
      {openEmailModal && (
        <Modal
          zIndex={100}
          centered={true}
          title="Forward Email"
          closable={false}
          visible={openEmailModal}
          width="90%"
          footer={[
            <Button
              disabled={emailSending}
              key="cancel"
              onClick={() => {
                setOpenEmailModal(false);
                setEventEntry(null);
              }}
            >
              <Icon type="close" />
              Close
            </Button>,
            <Button
              disabled={emailSending}
              type="primary"
              key="submit"
              onClick={async () => {
                setEmailSending(true);
                const result = await forwardEmail(session.authToken, {
                  id: eventEntry.id,
                  inputText: emailBody.replace(/\n/g, '<br />'),
                });

                if (result.data.responseCode === 0) {
                  const response = await getDashboard(session.authToken);
                  dispatch({
                    type: 'INIT_DASHBOARD',
                    payload: response.data.data,
                  });
                  setOpenEmailModal(false);
                  setEmailSending(false);
                } else {
                  message.error('Forward email failed');
                  setEmailSending(false);
                }
              }}
            >
              {emailSending ? <Icon type="loading" /> : <Icon type="check" />}
              Send
            </Button>,
          ]}
        >
          <div>
            <TextArea
              disabled={emailSending}
              placeholder="Write something here"
              style={{ resize: 'none' }}
              rows={8}
              autoComplete="off"
              value={emailBody}
              onChange={(e) => {
                setEmailBody(e.target.value);
              }}
            />
            <br />
            <br />
            <div
              style={{
                maxHeight: '175px',
                overflow: 'auto',
              }}
            >
              {eventEntry && eventEntry.body
                ? parse(eventEntry.body)
                : 'Not/Available'}
            </div>
            {eventEntry.emailAttachment &&
              eventEntry.emailAttachment.contact && (
                <div>
                  <Divider orientation="left">
                    <span>Attachment File(s)</span>
                  </Divider>
                  {eventEntry.emailAttachment.contact.map((i, index) => (
                    <div key={index}>
                      {index + 1}. {i.name}
                    </div>
                  ))}
                </div>
              )}
          </div>
        </Modal>
      )}

      {showVacancyDetailModal ? (
        <Modal
          zIndex={100}
          centered={true}
          title="Vacancy - Interview Follow Up(s)"
          closable={false}
          visible={showVacancyDetailModal}
          width="90%"
          footer={[
            <Button
              disabled={vacancyDetailLoading}
              key="cancel"
              onClick={() => {
                setShowVacancyDetailModal(false);
                setVacancyDetailData([]);
              }}
            >
              <Icon type="close" />
              Close
            </Button>,
          ]}
        >
          {vacancyDetailLoading ? (
            <center>
              <Spin spinning indicator={<Icon type="loading" />} />
              &nbsp;&nbsp;Loading...
            </center>
          ) : (
            <>
              {vacancyDetailData.length > 0 ? (
                <div style={{ maxHeight: '425px', overflow: 'auto' }}>
                  <EventsList data={vacancyDetailData} />
                </div>
              ) : (
                <center>
                  <div style={{ color: '#cccccc' }}>Data Not Available</div>
                </center>
              )}
            </>
          )}
        </Modal>
      ) : null}

      {showEditVacancyModal ? <NewVacancyForm /> : null}
      <Row>
        <Col span={6}>
          {renderCard('#B0BF1A', dashboard.totalEvents, 'Events', 'activities')}
        </Col>

        <Col span={6}>
          {renderCard(
            '#B284BE',
            dashboard.totalCandidates,
            'Candidates',
            'candidates',
          )}
        </Col>

        <Col span={6}>
          {renderCard(
            '#72A0C1',
            dashboard.totalContacts,
            'Contacts',
            'contacts',
          )}
        </Col>

        <Col span={6}>
          {renderCard('#DE5D83', dashboard.totalClients, 'Clients', 'clients')}
        </Col>
      </Row>

      <br />

      <Tabs type="card">
        <TabPane
          tab={
            <div>
              <FontAwesomeIcon icon={faChartBar} />
              &nbsp;&nbsp;Charts
            </div>
          }
          key="1"
        >
          <br />
          <Row>
            <Col span={7}>
              <ResponsiveContainer width={'100%'} height={250}>
                <ComposedChart data={data.reverse()}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="date" tick={<CustomizedAxisTick />} />
                  <YAxis allowDecimals={false} />
                  <Tooltip />
                  <Legend
                    content={() => (
                      <center>Number of events from last 7 days</center>
                    )}
                  />
                  <Area
                    type="monotone"
                    dataKey="events"
                    fill="#B0BF1A"
                    stroke="#72A0C1"
                  />
                </ComposedChart>
              </ResponsiveContainer>
            </Col>

            <Col span={8}>
              <ResponsiveContainer width={'100%'} height={250}>
                <ComposedChart
                  data={data3}
                  margin={{
                    top: 5,
                    right: 15,
                    bottom: 5,
                    left: 15,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="week" tick={<CustomizedAxisTick />} />
                  <YAxis allowDecimals={false} />
                  <Tooltip />
                  <Legend />
                  <Line type="monotone" dataKey="candidates" stroke="#DE5D83" />
                  <Bar dataKey="spec_and_cvsent" barSize={20} fill="#7CB9E8" />
                </ComposedChart>
              </ResponsiveContainer>
            </Col>

            <Col span={9}>
              <ResponsiveContainer width={'100%'} height={325}>
                <PieChart>
                  <Pie
                    activeIndex={activeIndex}
                    activeShape={renderActiveShape}
                    data={data1}
                    cy={125}
                    innerRadius={81}
                    outerRadius={108}
                    fill="#8884d8"
                    dataKey="value"
                    onMouseEnter={onPieEnter}
                  >
                    {data1.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={COLORS[index % COLORS.length]}
                      />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
            </Col>
          </Row>
        </TabPane>
      </Tabs>
      <Tabs type="card">
        <TabPane
          tab={
            <div>
              <FontAwesomeIcon icon={faCalendar} />
              &nbsp;&nbsp;Calendar
            </div>
          }
          key="1"
        >
          <MyCalendar
            invoiceReminders={dashboard.invoiceReminders}
            reminders={dashboard.reminders}
          />
        </TabPane>
        <TabPane
          tab={
            <div>
              <FontAwesomeIcon icon={faListUl} />
              &nbsp;&nbsp;Popular Lists
            </div>
          }
          key="2"
        >
          <Row>
            <Col span={8}>
              <div style={{ marginRight: '5px' }}>
                <List
                  header={<b>Interview arranged from last 30 days</b>}
                  bordered
                  dataSource={data5}
                  renderItem={(item) => (
                    <List.Item>
                      <div style={{ width: '100%' }}>
                        {renderInterview(item)}
                      </div>
                    </List.Item>
                  )}
                />
              </div>
            </Col>
            <Col span={8}>
              <div style={{ marginRight: '5px' }}>
                <List
                  header={<b>The most popular candidates from last 7 days</b>}
                  bordered
                  dataSource={data2}
                  renderItem={(item, index) => (
                    <List.Item>
                      <div style={{ width: '100%' }}>
                        {renderCandidate(item, index)}
                      </div>
                    </List.Item>
                  )}
                />
              </div>
            </Col>
            <Col span={8}>
              <List
                header={<b>Candidates created from last 7 days</b>}
                bordered
                dataSource={data4}
                renderItem={(item) => (
                  <List.Item>
                    <div style={{ width: '100%' }}>
                      {renderNewCandidate(item)}
                    </div>
                  </List.Item>
                )}
              />
            </Col>
          </Row>
        </TabPane>
        <TabPane
          tab={
            <div>
              <FontAwesomeIcon icon={faFileAlt} />
              &nbsp;&nbsp;Spec CV Sent / CV Sent{' '}
              <Badge
                count={data6.length}
                style={{ backgroundColor: '#B284BE' }}
              />
            </div>
          }
          key="3"
        >
          <Row>
            <Col span={24}>
              <List
                bordered
                dataSource={data6}
                renderItem={(item) => (
                  <List.Item>
                    <div style={{ width: '100%' }}>
                      {renderReadEvent(item, true, false, false, true)}
                    </div>
                  </List.Item>
                )}
              />
            </Col>
          </Row>
        </TabPane>
        <TabPane
          tab={
            <div>
              <FontAwesomeIcon icon={faFax} />
              &nbsp;&nbsp;To Business Development{' '}
              <Badge
                count={data7.length}
                style={{ backgroundColor: '#B284BE' }}
              />
            </div>
          }
          key="4"
        >
          <Row>
            <Col span={24}>
              <List
                bordered
                dataSource={data7}
                renderItem={(item) => (
                  <List.Item>
                    <div style={{ width: '100%' }}>
                      {renderReadEvent(item, false, false, true, false)}
                    </div>
                  </List.Item>
                )}
              />
            </Col>
          </Row>
        </TabPane>
        <TabPane
          tab={
            <div>
              <FontAwesomeIcon icon={faUserCheck} />
              &nbsp;&nbsp;To Follow-Up{' '}
              <Badge
                count={data8.length}
                style={{ backgroundColor: '#B284BE' }}
              />
            </div>
          }
          key="5"
        >
          <Row>
            <Col span={24}>
              <List
                bordered
                dataSource={data8}
                renderItem={(item) => (
                  <List.Item>
                    <div style={{ width: '100%' }}>
                      {renderFollowUpEvent(item, false, true, false, false)}
                    </div>
                  </List.Item>
                )}
              />
            </Col>
          </Row>
        </TabPane>
        <TabPane
          tab={
            <div>
              <FontAwesomeIcon icon={faFileWord} />
              &nbsp;&nbsp;Vacancy{' '}
              <Badge
                count={vacancies.length}
                style={{ backgroundColor: '#B284BE' }}
              />
            </div>
          }
          key="6"
        >
          <Spin
            spinning={updating || vacancyLoading}
            indicator={<Icon type="loading" />}
          >
            {vacancies.length > 0 ? (
              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="drag-drop">
                  {(provided) => (
                    <div
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      style={style.dragableContent}
                    >
                      {vacancies.map(($, index) => (
                        <Draggable key={$.id} draggableId={$.id} index={index}>
                          {(p) => (
                            <div
                              ref={p.innerRef}
                              {...p.draggableProps}
                              {...p.dragHandleProps}
                            >
                              <div style={style.dragableItemContent}>
                                {renderVacancy($, index + 1)}
                              </div>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            ) : (
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )}
          </Spin>
        </TabPane>
      </Tabs>
    </React.Fragment>
  );
}

export default Dashboard;
